import { useCallback, useState } from 'react';

const emptySelection: ReadonlySet<string> = new Set();

export function useIntegrationsSelection(resetKey: string) {
  const [selected, setSelected] = useState<ReadonlySet<string>>(emptySelection);
  const [lastResetKey, setLastResetKey] = useState(resetKey);

  if (lastResetKey !== resetKey) {
    setLastResetKey(resetKey);
    if (selected.size > 0) setSelected(emptySelection);
  }

  const toggle = useCallback((id: string, checked: boolean) => {
    setSelected((current) => {
      const next = new Set(current);
      if (checked) next.add(id);
      else next.delete(id);
      return next;
    });
  }, []);

  const toggleAll = useCallback((ids: readonly string[], checked: boolean) => {
    setSelected(checked ? new Set(ids) : emptySelection);
  }, []);

  const clear = useCallback(() => {
    setSelected(emptySelection);
  }, []);

  return { selected, toggle, toggleAll, clear };
}

export function integrationsSelectionHeaderState(
  selected: ReadonlySet<string>,
  pageIds: readonly string[],
): boolean | 'indeterminate' {
  if (pageIds.length === 0) return false;
  const selectedOnPage = pageIds.filter((id) => selected.has(id)).length;
  if (selectedOnPage === 0) return false;
  return selectedOnPage === pageIds.length ? true : 'indeterminate';
}
